import React from "react";
import { useNavigate } from "react-router-dom";
import { Breadcrumb } from "antd";
import { useTranslation } from "react-i18next";

export default function UsersCreateBreadcrumb() {
  const navigate = useNavigate();
  const [t] = useTranslation("global");

  const navigateToUsers = () => {
    navigate({
      pathname: "/organization-management/users",
    });
  };

  return (
    <Breadcrumb className="">
      <Breadcrumb.Item>{t("header.organizationManagement")}</Breadcrumb.Item>
      <Breadcrumb.Item
        onClick={() => {
          navigateToUsers();
        }}
        className="generalStyles__breadcrumbItemInactive"
      >
        {t("header.users")}
      </Breadcrumb.Item>
      <Breadcrumb.Item className="generalStyles__breadcrumbItem">
        {t("userManagement.createNewUser")}
      </Breadcrumb.Item>
    </Breadcrumb>
  );
}
